<template>
  <pt-qr-code-form class="pt-qr-code-form__page" :isEdit="is_edit" :id="id"></pt-qr-code-form>
</template>

<script>
import PtQrCodeForm from 'cps/mall-manage/pt-goods-qr-code/pt-qr-code-form'
export default {
  name: 'pt-qr-code-form__view',
  components: {
    'pt-qr-code-form': PtQrCodeForm
  },
  props: {
    isEdit: {
      type: [Boolean, String],
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
